// HTML-escape customer-controlled strings (block / cultivar / station / pest names) before they are
// interpolated into useHTML markup (chart tooltip, legend rows), so a value like
// `<img src=x onerror=...>` can't execute. Escape at each interpolation site.
export const escapeHtml = (value: string | null | undefined): string =>
  (value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
